import { groupBy, sortBy } from 'lodash';

export default {
    getUniqueValues(sourceList, attributeName) {
        // will return an array of unique values from an array of objects
        // attributeName: building, floor, wing...
        return Array.from(
            new Set(
                sourceList.map(item => {
                    return item[attributeName];
                })
            )
        );
    },
    buildTopology(sourceList) {
        // will group rooms by building, wing
        let result = [];
        const mappedSource = this.mapSpaces(sourceList);
        const uniqueBuildings = this.getUniqueValues(mappedSource, 'building');
        uniqueBuildings.forEach(building => {
            const buildingList = mappedSource.filter(
                item => item.building === building
            );
            if (building === undefined || building === '') {
                const uniqueWings = this.getUniqueValues(buildingList, 'wing');
                uniqueWings.forEach(wing => {
                    const wingList = buildingList.filter(
                        item => item.wing === wing
                    );
                    const wingNode = this.getGroupedList(
                        wingList,
                        building,
                        wing
                    );
                    if (wingNode) {
                        result.push(wingNode);
                    }
                });
            } else {
                const buildingNode = this.getGroupedList(
                    buildingList,
                    building
                );
                if (buildingNode) {
                    result.push(buildingNode);
                }
            }
        });
        return this.sortBuildings(result);
    },
    getGroupedList(sourceList, building, wing) {
        let result;
        let key, title, type;
        if (wing && building) {
            type = 'wing';
            key = `${
                building ? building.replace(/\s/g, '_') + '_' : ''
            }${wing.replace(/\s/g, '_')}`;
            title = `${
                building ? 'Building: ' + building + ', ' : ''
            }Wing: ${wing}`;
        } else if (building && !wing) {
            type = 'building';
            key = `${building.replace(/\s/g, '_')}`;
            title = `Building: ${building}`;
        } else if (wing && !building) {
            type = 'wing';
            key = `${wing.replace(/\s/g, '_')}`;
            title = `Wing: ${wing}`;
        } else if (!building && !wing) {
            type = 'building';
            key = 'other';
            title = 'Building: Other';
        }
        result = {
            key: key,
            title: title,
            type: type,
            floors: this.getFloors(sourceList)
        };
        return result;
    },
    getFloors(sourceList) {
        // will group rooms by floors
        let floors = [];
        let uniqueWings = this.getUniqueValues(sourceList, 'wing');
        uniqueWings.forEach(wing => {
            const wingList = sourceList.filter(item => item.wing === wing);
            let uniqueFloors = this.getUniqueValues(wingList, 'floor');
            uniqueFloors.forEach(floor => {
                const subList = wingList.filter(item => item.floor === floor);
                if (subList.length) {
                    floors.push({
                        type: 'floor',
                        key: wing
                            ? `a_${wing.replace(/\s/g, '_')}_${floor.replace(
                                  /\s/g,
                                  '_'
                              )}`
                            : `b_${floor.replace(/\s/g, '_')}`,
                        title: wing
                            ? `Wing: ${wing}, Floor: ${floor}`
                            : `Floor: ${floor}`,
                        rooms: this.sortRooms(subList)
                    });
                }
            });
        });

        return this.sortFloors(floors);
    },
    sortFloors(sourceList) {
        return [...sourceList].sort((a, b) => {
            return a.key > b.key ? 1 : a.key < b.key ? -1 : 0;
        });
    },
    sortRooms(sourceList) {
        // if all rooms have numeric room numbers then sort numerically
        // else sort alphabetically
        return sortBy(sourceList, item =>
            isNaN(item.room) ? item.room : Number(item.room)
        );
    },
    sortBuildings(sourceList) {
        return [...sourceList].sort((a, b) => {
            if (a.type === b.type) {
                return a.key > b.key ? 1 : a.key < b.key ? -1 : 0;
            } else {
                return a.type === 'wing' ? -1 : 1;
            }
        });
    },
    getDevicesGroupedByStatus(deviceList) {
        const groupedByStatus = groupBy(
            deviceList.map(device => {
                return {
                    healthCheckStatus:
                        device.healthCheckStatus === undefined
                            ? 'UNKNOWN'
                            : device.healthCheckStatus
                };
            }),
            'healthCheckStatus'
        );
        return groupedByStatus;
    },
    mapSpaces(source) {
        // will clean the undefined and empty string values
        return source.map(item => {
            return {
                ...item,
                building: item.building ? item.building : '',
                wing: item.wing ? item.wing : ''
            };
        });
    }
};
